





















import Vue from 'vue';
import { Segment } from '@/models/skills/blows/types';
import { blowDisplayName } from '@/models/skills/blows/registry';
import { spanColorIndex } from '@/models/skills/blows/spans';
import SkillRef from './SkillRef.vue';
import ItemRef from './ItemRef.vue';
import StateVfxChip from './StateVfxChip.vue';
import BlowChildCard from './BlowChildCard.vue';
import EnhanceTableRows from './EnhanceTableRows.vue';

export default Vue.extend({
    name: 'BlowSegments',
    components: {
        SkillRef,
        ItemRef,
        StateVfxChip,
        BlowChildCard,
        EnhanceTableRows,
    },
    props: {
        segments: {
            type: Array as () => Segment[],
            required: true,
        },
        spans: {
            type: Array as () => Array<[number, number]> | null,
            default: null,
        },
    },
    methods: {
        isText(s: Segment): boolean {
            return typeof s === 'string';
        },
        blowName(id: number): string {
            return blowDisplayName(id);
        },
        spanClass(s: Segment): string {
            if (typeof s === 'string' || !this.spans) {
                return '';
            }
            const span = (s as any).span;
            if (!span) {
                return '';
            }
            const idx = spanColorIndex(this.spans, span);
            if (idx === -1) {
                return '';
            }
            return 'pspan-' + idx;
        },
    },
});
